import { adjustPathname } from '@monoimin/utils/helpers';

import { getLocalePrefix } from '@monoimin/intl';

import createEstateUrlPath from '../createEstateUrlPath';

import type { Locales, StrapiEstate } from '@monoimin/sb-types';

type Alternates = {
  canonical: string;
  languages?: { [language: string]: string };
};

export const defineRealEstatePageAlternates = (
  estate: StrapiEstate,
  removeRealEstate?: boolean
): Alternates | null => {
  const { localizations, locale, country, slug } = estate;

  const haveLocalizations = Array.isArray(localizations);

  const isOneLanguage = haveLocalizations && localizations.length === 0;
  const localePrefix = getLocalePrefix(locale as Locales);

  const canonical = adjustPathname(
    createEstateUrlPath(localePrefix, country?.slug, slug, removeRealEstate)
  );

  if (isOneLanguage) {
    return {
      canonical,
    };
  }

  if (haveLocalizations && localizations.length) {
    const languages = localizations.reduce(
      (acc, item) => {
        const itemLocale = item.locale as Locales;

        const localePrefix = getLocalePrefix(itemLocale);

        return {
          ...acc,
          [itemLocale]: adjustPathname(
            createEstateUrlPath(
              localePrefix,
              country?.slug,
              item.slug,
              removeRealEstate
            )
          ),
        };
      },
      {
        [locale as string]: canonical,
      }
    );
    return {
      canonical,
      languages,
    };
  }

  return null;
};

export default defineRealEstatePageAlternates;
